import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `http://190.92.148.245/Da7ktnaAPI/APIs/`
})

